import {createSlice} from "@reduxjs/toolkit";

export const activityTypeFiltersSlice = createSlice({
    name: 'activityTypeFilters',
    initialState: {
        searchVal: '',
        filters: {
            activityTypeId: {value: null},
        },
    },
    reducers: {
        setSearchVal: (state, action) => {
            state.searchVal = action.payload;
        },
        setFilters: (state, action) => {
            state.filters = action.payload;
        }
    },
});

export const { setSearchVal, setFilters } = activityTypeFiltersSlice.actions;
export default activityTypeFiltersSlice.reducer;
